<div class="mb-3">
  <app-tab-switcher *ngIf="currentStart">
    <button *ngIf="view !== 'month'"
            class="custom-col small btn-link btn btn-sm rounded-0"
            (click)="weekJump.emit(0)"
            [ngClass]="{
  'active': isThisWeek(currentStart),
  'text-muted': !isThisWeek(currentStart),
  'text-body': isThisWeek(currentStart)
}"
            type="button"
    >
      {{ 'authenticated.event_calendar.this_week' | translate }}
    </button>

    <button *ngIf="view !== 'month'"
            class="custom-col small  btn-link btn btn-sm rounded-0"
            (click)="weekJump.emit(1)"
            [ngClass]="{
  'active': isNextWeek(currentStart, 1),
  'text-muted': !isNextWeek(currentStart, 1),
  'text-body': isNextWeek(currentStart, 1)
}"
            type="button"
    >
      {{ 'authenticated.event_calendar.next_week' | translate }}
    </button>

    <ng-template [ngIf]="view !== 'month'">
      <button
        *ngFor="let week of [2,3,4,5,6,7,8]"
        class="custom-col small  btn-link btn btn-sm rounded-0"
        (click)="weekJump.emit(week)"
        [ngClass]="{
    'active': isNextWeek(currentStart ?? DateTime.now(), week),
    'text-muted': !isNextWeek(currentStart ?? DateTime.now(), week),
    'text-body': isNextWeek(currentStart ?? DateTime.now(), week)
  }"
        type="button"
      >
        {{ addWeeks(startOfWeek(now), week).toJSDate() | formatInTimeZone: dfnsLocale: "dd.MM" }}
        /{{ addDays(addWeeks(startOfWeek(now), week), 6).toJSDate() |formatInTimeZone:dfnsLocale:"dd.MM" }}
      </button>
    </ng-template>

    <div style="width: 160px" class="custom-col d-flex p-0 align-content-center ms-auto me-2 border-0">

      <div class="input-group d-flex align-items-center" *ngIf="view === 'month'">
        <input type="text" class="form-control form-control-sm pointer" style="height: fit-content"
               [placeholder]=" 'authenticated.event_calendar.choose_month' | translate"
               (bsValueChange)="dateChange.emit($event)"
               [bsConfig]="{containerClass: 'theme-dark-blue', adaptivePosition: true, useUtc: true }"
               bsDatepicker
        />

        <div style="height: 55px;"></div>
      </div>

      <div class="input-group" *ngIf="view !== 'month'">

        <input type="text" class="form-control form-control-sm pointer "
               *ngIf="view === 'week'"
               [placeholder]=" 'authenticated.event_calendar.choose_week' | translate"
               (bsValueChange)="dateChange.emit($event)"
               [daysDisabled]="[0,2,3,4,5,6]"
               [bsConfig]="{selectWeek: true,   containerClass: 'theme-dark-blue', adaptivePosition: true, useUtc: true }"
               bsDatepicker
        />

        <input type="text" class="form-control form-control-sm pointer "
               *ngIf="view === 'day'"
               [placeholder]=" 'authenticated.event_calendar.choose_day' | translate"
               (bsValueChange)="dateChange.emit($event)"
               [bsConfig]="{selectWeek: true,   containerClass: 'theme-dark-blue', adaptivePosition: true, useUtc: true }"
               bsDatepicker
        />
      </div>

    </div>


  </app-tab-switcher>
</div>
